__turbopack_context__.v({
  "button": "lopsqq_button" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "iconFavorite": "lopsqq_iconFavorite",
  "iconNotFavorite": "lopsqq_iconNotFavorite",
});
